import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Grid,
} from "@mui/material";
import {
  HelpOutline as HelpIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { THREE_SLOT_CONFIG } from "./threeSlotConfig";

const ThreeSlotWorking = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <Accordion
        sx={{
          borderRadius: `${borderRadiusPx.lg} !important`,
          border: `1px solid ${colors.dashboard.cardBorder}`,
          boxShadow: "none",
          backgroundColor: colors.dashboard.cardBg,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <HelpIcon sx={{ color: colors.primary.main, fontSize: 22 }} />
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 700, color: colors.slate[900] }}
            >
              {`How does ${THREE_SLOT_CONFIG.name} work?`}
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0, pb: 3, px: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2,
                  bgcolor: colors.slate[50],
                  borderRadius: borderRadiusPx.md,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 700, color: colors.primary.main, mb: 0.5 }}
                >
                  1. Set Your BET
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Choose the amount of BET you want to wager per spin.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2,
                  bgcolor: colors.slate[50],
                  borderRadius: borderRadiusPx.md,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 700, color: colors.primary.main, mb: 0.5 }}
                >
                  2. Spin the Reels
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Click SPIN and watch the three reels spin. Match all three symbols to win big!
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 2,
                  bgcolor: colors.slate[50],
                  borderRadius: borderRadiusPx.md,
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 700, color: colors.primary.main, mb: 0.5 }}
                >
                  3. Win Jackpots
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  Progressive jackpots are built from community wagers. Win the Mini, Major, or Mega jackpot based on your symbol matches.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ThreeSlotWorking;
